import { render } from "./WorkColumn.vue?vue&type=template&id=493b0608"
import script from "./WorkColumn.vue?vue&type=script&lang=js"
export * from "./WorkColumn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__